"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decode_class = exports.DetectAdblock = exports.DetectByGoogleAd = void 0;
var DetectorModal_1 = __importDefault(require("./DetectorModal"));
var CryptoJS = __importStar(require("crypto-js"));
var is_connected = function () {
    return window.navigator.onLine;
};
var fairAdblockRequest = function () {
    var fairAdblockStyle = document.getElementById('stndz-style');
    return null !== fairAdblockStyle;
};
var DetectByGoogleAd = function (callback) {
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    var done = false;
    var windowElement;
    if (!is_connected()) {
        callback(false);
        return;
    }
    var reqURL = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
    script.setAttribute("src", reqURL);
    script.setAttribute("type", "text/javascript");
    script.setAttribute("charset", "utf-8");
    var alreadyDetectedByAdd = false;
    script.onload = function () {
        var _a;
        if (!done) {
            done = true;
            script.onload = null;
            if ((windowElement === null || windowElement === void 0 ? void 0 : windowElement.adsbygoogle) == 'undefined') {
                callback(true);
                alreadyDetectedByAdd = true;
            }
            (_a = script.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(script);
        }
    };
    script.onerror = function () {
        callback(true);
    };
    if (alreadyDetectedByAdd) {
        return;
    }
    var callbacked = false;
    var request = new XMLHttpRequest();
    request.open('GET', reqURL, true);
    request.onreadystatechange = function () {
        if (request.status === 0 || (request.status >= 200 && request.status < 400)) {
            if (request.responseText.toLowerCase().indexOf("ublock") > -1
                || request.responseText.toLowerCase().indexOf("height:1px") > -1) {
                if (callbacked) {
                    callback(true);
                    return;
                }
                callbacked = true;
            }
        }
        if (!callbacked) {
            callback(request.responseURL !== reqURL);
            return;
        }
    };
    request.send();
    head.insertBefore(script, head.firstChild);
};
exports.DetectByGoogleAd = DetectByGoogleAd;
var DetectAdblock = function (callback) {
    if (fairAdblockRequest()) {
        callback(true);
    }
    else {
        (0, exports.DetectByGoogleAd)(function (blocked) {
            if (blocked) {
                callback(true);
            }
            else {
                callback(false);
            }
        });
    }
};
exports.DetectAdblock = DetectAdblock;
var removeLeadingNumbers = function (inputString) {
    while (/^\d/.test(inputString)) {
        inputString = inputString.slice(1);
    }
    return inputString;
};
var decode_class = function (className, sessionKey) {
    var newClassName = className + sessionKey + className;
    return removeLeadingNumbers(CryptoJS.SHA256(newClassName).toString());
};
exports.decode_class = decode_class;
exports.default = DetectorModal_1.default;
//# sourceMappingURL=index.js.map